import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';


import DataTable from './datatable';

import ContainerHeader from '../../../components/ContainerHeader/index';
import * as templatedetails from '../../../actions/templatedetails';

class TemplateList extends Component {

    componentDidMount() {
        // console.log('props', this.props)
        this.props.actions.fetchTemplateList();
    }

    render() {
        const { getDataList, match } = this.props;

        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('getDataList', getDataList);
        if (getDataList && getDataList.Status) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (getDataList && getDataList.templatedetailsList && getDataList.templatedetailsList.length > 0) {
            // dataList = getDataList.templatedetailsList.map((_data, index) => {
            //     return (<TableCell key={index} data={_data} index={index} />);
            // })
        }
        // console.log(getDataList);
        return (
            <div className="slideInUpTiny ">
            {message}
                <ContainerHeader title="Template List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        
                    <div className="row">
                            <div className="col-12">
                                <h4 className="bg-primary text-white p-3 mb-0">Template List</h4>
                                <DataTable data={getDataList && getDataList.templatedetailsList && getDataList.templatedetailsList.length > 0 ? getDataList.templatedetailsList : null} />
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { templateDetails } = state
    const { match } = ownProps
    // console.log(templateDetails);
    return { getDataList: templateDetails, match }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(templatedetails, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(TemplateList);



// WEBPACK FOOTER //
// ./app/templatedetails/templatelist/index.js